import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as React from "react"
import { bindActionCreators, Dispatch } from "redux"
import { connect } from "react-redux"
import { RouteComponentProps } from "react-router"
import DetailServiceModal from "./detail-service-modal"
import Toolbar, { ToolbarItem } from "../toolbar"
import { Service, ServiceGroup, ElementAnalytiqueBergerLevrault } from "../../model"
import { deleteService } from "../../service/sfp/services-service"
import { ReducerState, MappedActionsProps } from "../../reducer"
import * as actionCreators from "../../action-creators"
import { DELETE } from "../../constant/misc"
import { sortServices } from "../../domain/sfp/service-domain"
import { Profile, getProfile } from "../../domain/sfp/user-domain"
import { findServicesBL } from "../../service/sfp/berger-levrault-ws-service"
import { findServiceGroups,findPolitique } from "../../service/sfp/service-group-service"

class Services extends React.Component<InjectedProps, State> {
	constructor(props: Readonly<InjectedProps>) {
		super(props)
		this.state = {
			addGroup: false,
			addService: false,
			analyticElements: [],
			analyticElementsLoaded: false,
			deletingServices: [],
			groups: [],
			loadingAnalyticElements: false,
			loadingServiceGroups: false,
			serviceGroupsLoaded: false,
			viewService: null,
			Politique: [],
			loadingPolitique: false,
			PolitiqueLoaded: false
		}
	}

	componentDidMount() {
		this.initData(this.props)
	}

	componentWillReceiveProps(props: Readonly<InjectedProps>) {
		this.initData(props)
	}

	componentDidUpdate(prevProps) {
		if(prevProps.currentLocalAuthority && this.props.currentLocalAuthority && prevProps.currentLocalAuthority.approaches.length !== this.props.currentLocalAuthority.approaches.length ){
			this.initData(this.props)
		}		
	}

	render() {
		const loading = this.props.loadingCurrentLocalAuthority
		|| this.props.loadingCurrentLocalAuthorityServices
		|| this.state.loadingAnalyticElements

		if (loading) return <section className="section">Chargement...</section>

		const consulted = getProfile(this.props.currentUser) === Profile.LocalAuthorityConsultant

		return <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
			<Toolbar
			items={this.getToolbarItems(consulted)}
			loading={loading}
			user={this.props.currentUser} />

			<table className="table is-narrow">
				<thead>
					<tr>
						<th>Nom</th>
						<th>Code</th>
						<th>Description</th>
						<th>Nom du service rattaché</th>
						<th></th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					{!(this.props.currentLocalAuthorityServices && 0 !== this.props.currentLocalAuthorityServices.length)
					? <tr>Aucun service disponible</tr>
					: this.props.currentLocalAuthorityServices.map((service, i) => {
						const deleting = !!this.state.deletingServices
						.find(s => s.slug === service.slug)

						const matchingAnalyticElement = this.state.analyticElements
						.find(ae => ae.codeElement === service.code)

						return <tr key={i}>
							<td>{service.label}</td>
							<td>{service.code}</td>
							<td>{service.description}</td>
							<td>{matchingAnalyticElement ? matchingAnalyticElement.libelleElement : null}</td>
							{ consulted
							? null
							: [
								<td key={0}>
									<button
									className={`button is-small${deleting ? " is-loading" : ""}`}
									disabled={deleting}
									title="Voir le détail"
									type="button"
									onClick={() => this.handleClickViewService(service)}>
										<span className="icon is-small">
											<FontAwesomeIcon icon="eye" />
										</span>
									</button>
								</td>,
								<td key={1}>
									<button
									className={`button is-small is-danger is-outlined${deleting ? " is-loading" : ""}`}
									disabled={deleting}
									title="Supprimer le service"
									type="button"
									onClick={() => this.handleClickDeleteService(service)}>
										<span className="icon is-small">
											<FontAwesomeIcon icon="trash" />
										</span>
									</button>
								</td>
							]}
						</tr>
						})}
				</tbody>
			</table>

			{this.state.addService &&
			<DetailServiceModal
			groups={this.state.groups}
			Politique={this.state.Politique}
			loading={loading}
			localAuthority={this.props.currentLocalAuthority}
			servicesBL={this.state.analyticElements}
			onClose={() => this.handleCloseAddServiceModal()}
			onError={r => this.handleError(r)}
			onServiceCreated={s => this.handleServiceCreated(s)}/>}

			{this.state.viewService &&
			<DetailServiceModal
			groups={this.state.groups}
			Politique={this.state.Politique}
			loading={loading}
			localAuthority={this.props.currentLocalAuthority}
			service={this.state.viewService}
			servicesBL={this.state.analyticElements}
			onClose={() => this.handleCloseEditServiceModal()}
			onError={r => this.handleError(r)}
			onServiceUpdated={s => this.handleServiceUpdated(s)}/>}
		</div>
	}

	private getToolbarItems(consulted: boolean): ToolbarItem[] {
		const items: ToolbarItem[] = []
		consulted ? null : items.push({
			onClick: () => this.handleClickAddService(),
			text: "Ajouter un service",
			title: "Ajouter un service"
		})
		return items
	}

	private handleClickAddService(): void {
		this.setState({ addService: true })
	}

	private handleClickDeleteService(service: Service): void {
		let message = `Vous êtes sur le point de supprimer le service "${service.label}".\n`
		message += `Veuillez saisir "${DELETE}" pour confirmer.`

		if (prompt(message) !== DELETE) return

		this.setState(prevState => {
			prevState.deletingServices.push(service)
			return prevState
		})

		service.localAuthority = this.props.currentLocalAuthority.id

		deleteService(service)
		.then(() => {
			const services = this.props.currentLocalAuthorityServices
			const id = this.props.currentLocalAuthority.id
			const serviceIndex = services.findIndex(s => s.slug === service.slug)
			services.splice(serviceIndex, 1)

			const deletingServices = this.state.deletingServices
			const deletedServiceIndex = deletingServices.findIndex(ds => ds.slug === service.slug)
			deletingServices.splice(deletedServiceIndex, 1)

			this.setState({ deletingServices }, () => {
				this.props.actions.updateServicesLocally(services)
				this.props.actions.fetchCurrentLocalAuthorityIfCollectivitiesPage(id)
			})
		})
		.catch(reason => {
			const deletingServices = this.state.deletingServices
			const deletedServiceIndex = deletingServices.findIndex(ds => ds.slug === service.slug)
			deletingServices.splice(deletedServiceIndex, 1)

			this.props.actions.throwError(reason)
			this.setState({ deletingServices })
		})
	}

	private handleClickViewService(service: Service): void {
		this.setState({ viewService: service })
	}

	private handleCloseAddServiceModal(): void {
		this.setState({ addService: false })
	}

	private handleCloseEditServiceModal(): void {
		this.setState({ viewService: null })
	}

	private handleError(reason: any): void {
		this.props.actions.throwError(reason)
	}

	private initData(props: InjectedProps): void {
		if (!props.currentLocalAuthority) return

		if (!this.state.loadingServiceGroups && !this.state.serviceGroupsLoaded) {
			this.setState({ loadingServiceGroups: true }, () => {
				findServiceGroups(props.currentLocalAuthority)
				.then(groups => this.setState({
					groups,
					loadingServiceGroups: false,
					serviceGroupsLoaded: true
				}))
				.catch(reason => this.setState({
					groups: [],
					loadingServiceGroups: false,
					serviceGroupsLoaded: true
				}))
			})
		}
		if (!this.state.loadingPolitique && !this.state.PolitiqueLoaded) {
			this.setState({ loadingPolitique: true }, () => {
				findPolitique(props.currentLocalAuthority)
				.then(Politique => this.setState({
					Politique,
					loadingPolitique: false,
					PolitiqueLoaded: true
				}))
				.catch(reason => this.setState({
					Politique: [],
					loadingPolitique: false,
					PolitiqueLoaded: true
				}))
			})
		}

		if (this.state.loadingAnalyticElements) return
		if (this.state.analyticElementsLoaded) return
		if (!props.currentLocalAuthority.bergerLevrault) return
		if (!props.currentLocalAuthority.bergerLevrault.enabled) return

		this.setState({ loadingAnalyticElements: true }, () => {
			findServicesBL(props.currentLocalAuthority.id)
			.then(analyticElements => {
				analyticElements.sort((a, b) => {
					if(a.codeElement < b.codeElement) { return -1; }
					if(a.codeElement > b.codeElement) { return 1; }
					return 0
				})

				this.setState({
					analyticElements,
					loadingAnalyticElements: false,
					analyticElementsLoaded: true
				})
			})
			.catch(() => this.setState({
				loadingAnalyticElements: false,
				analyticElementsLoaded: false
			}))
		})
	}

	private handleServiceCreated(service: Service): void {
		const id = this.props.currentLocalAuthority.id
		this.setState({ addService: false }, () => {
			const services = this.props.currentLocalAuthorityServices.slice()
			services.push(service)
			sortServices(services)
			this.props.actions.updateServicesLocally(services)
			this.props.actions.fetchCurrentLocalAuthorityIfCollectivitiesPage(id)
		})
	}

	private handleServiceUpdated(service: Service): void {
		const id = this.props.currentLocalAuthority.id
		this.setState({ viewService: null }, () => {
			const services = this.props.currentLocalAuthorityServices.slice()
			const index = services.findIndex(s => s.slug === service.slug)
			services[index] = service
			this.props.actions.updateServicesLocally(services)
			this.props.actions.fetchCurrentLocalAuthorityIfCollectivitiesPage(id)
		})
	}

}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
	return state
}

export default connect(mapStateToProps, mapDispatchToProps)(Services)

export interface Props {}

interface Params {}

interface State {
	addGroup: boolean
	addService: boolean
	deletingServices: Service[]
	groups: ServiceGroup[]
	loadingAnalyticElements: boolean
	loadingServiceGroups: boolean
	analyticElements: ElementAnalytiqueBergerLevrault[]
	analyticElementsLoaded: boolean
	serviceGroupsLoaded: boolean
	viewService: Service
	Politique: any,
	loadingPolitique: boolean,
	PolitiqueLoaded: boolean
}

type InjectedProps = MappedActionsProps &
Props &
ReducerState &
RouteComponentProps<Params>



// WEBPACK FOOTER //
// ./src/component/services/index.tsx